/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserPatientOpsProfileUpdate } from './userPatientOpsProfileUpdate';
import { RoleEnum } from './roleEnum';
import { UserAppointmentResourceUpdate } from './userAppointmentResourceUpdate';
import { GenderEnum } from './genderEnum';
import { UserTherapistProfileUpdate } from './userTherapistProfileUpdate';


/**
 * Partial update of a user and its profiles from the users tab, saved together.  Each profile section is optional; sending one for a profile the user does not have yet creates it. Changing the role into a branch creates that branch\'s profiles as well, and switches the appointment resource on or off when entering or leaving the therapist branch. Who may send which field is checked by the view.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PatchedUserUpdate { 
    name?: string;
    email?: string;
    gender?: GenderEnum;
    role?: RoleEnum;
    groups?: Array<number>;
    userPermissions?: Array<number>;
    /**
     * Legt fest, ob dieser Benutzer aktiv ist. Kann deaktiviert werden, anstatt Benutzer zu löschen.
     */
    isActive?: boolean;
    therapistProfile?: UserTherapistProfileUpdate;
    appointmentResource?: UserAppointmentResourceUpdate;
    patientOpsProfile?: UserPatientOpsProfileUpdate;
}
export namespace PatchedUserUpdate {
}

export const PatchedUserUpdate_name_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];

export const PatchedUserUpdate_email_Validators: ValidatorFn[] =
    [  Validators.maxLength(254), Validators.email,];

export const PatchedUserUpdate_gender_Validators: ValidatorFn[] =
    [ ];

export const PatchedUserUpdate_role_Validators: ValidatorFn[] =
    [ ];

export const PatchedUserUpdate_groups_Validators: ValidatorFn[] =
    [ ];

export const PatchedUserUpdate_userPermissions_Validators: ValidatorFn[] =
    [ ];

export const PatchedUserUpdate_isActive_Validators: ValidatorFn[] =
    [ ];

export const PatchedUserUpdate_therapistProfile_Validators: ValidatorFn[] =
    [ ];

export const PatchedUserUpdate_appointmentResource_Validators: ValidatorFn[] =
    [ ];

export const PatchedUserUpdate_patientOpsProfile_Validators: ValidatorFn[] =
    [ ];


